import classNames from 'classnames'

import Card from '../ui/Card/Card'
import styles from './ProductCards.module.scss'
import { getImageUrl, isLanguage } from '../../utils'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'

function ProductCards({
  cards = [],
  selectedCard,
  cardClickHandler,
  className,
  cardClass,
  overlayClass,
}) {
  const { language } = useLanguage()
  const { isFrench } = isLanguage(language?.code)

  const onClickHandler = (card) => {
    if (cardClickHandler) {
      cardClickHandler(card)
    }
  }
  return (
    <div className={classNames(styles.cardContainer, className)}>
      {cards.map((card, i) => (
        <Card
          key={card.title + card?.id}
          className={classNames(styles.cardHolder, cardClass)}
          onClickHandler={() => {
            onClickHandler(card)
          }}
          style={{
            backgroundImage: `url(${getImageUrl(card?.cardimage)})`,
          }}
        >
          <div
            className={classNames(styles.overlay, overlayClass, {
              [styles.selectedCard]: card?.id === selectedCard?.id,
              [styles.fr_overlay]: isFrench,
            })}
          >
            <span>{card?.title}</span>
          </div>
        </Card>
      ))}
    </div>
  )
}

export default ProductCards
